import { combineReducers } from 'redux';

// Biuwer Data queries reducers
import datamodelQueries from "./datamodel-queries/datamodel-queries-reducers";
import datasetQueries from "./dataset-queries/dataset-queries-reducers";

export default combineReducers({
    datamodelQueries,
    datasetQueries
});